.p {
  @include paragraph();
}

.p-secondary {
  @include paragraph('secondary');
}

.p-tertiary {
  @include paragraph('tertiary');
}

.span {
  @include span();
}

.span-secondary {
  @include span('secondary');
}

.span-tertiary {
  @include span('tertiary');
}

.small {
  @include small();
}

.small-secondary {
  @include small('secondary');
}

.small-tertiary {
  @include small('tertiary');
}

.text-bold {
  font-weight: var(--font-weight-semibold, $font-weight-semibold);
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.text-inactive {
  color: var(--text-color-inactive, text-color('inactive'));
}